<div id="root-element">
    <h2>Installationsbeschreibung</h2>
    <div id="tool-bar">
        <button mat-icon-button *ngIf="isReadonly" color="accent" (click)="delete()">
            <mat-icon>delete</mat-icon>
         </button>
        <button mat-icon-button *ngIf="isReadonly" color="accent" (click)="startEdit()">
            <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button *ngIf="!isReadonly" color="accent" (click)="discardChanges()">
            <mat-icon>clear</mat-icon>
        </button>
        <button mat-icon-button *ngIf="!isReadonly" color="accent" (click)="saveChanges()">
            <mat-icon>done</mat-icon>
        </button>
    </div>
    <textarea matInput 
              [disabled]="isReadonly"
              [ngModel]="internalText" 
              (ngModelChange)="internalText=$event">
    </textarea>
</div>

